import React from 'react';

import { Rule } from '../rule';
import { RuleInput } from '../rule-input';

import { type EditableRuleProps } from './types';

export const EditableRule: React.FC<EditableRuleProps> = (props) => {
	if (props.isEditing) {
		return (
			<RuleInput
				value={props.rule}
				notifyTypes={props.notifyTypes}
				onCancel={props.onCancel}
				onChange={props.onChange}
			/>
		);
	}

	return (
		<Rule
			data={props.rule}
			onEdit={props.onEdit}
			onDelete={props.onDelete}
			inlineResponder={props.rule.inlineResponder}
			shouldHideEditButton={props.shouldHideEditButton}
			shouldHideDeleteButton={props.shouldHideDeleteButton}
		/>
	);
};
